module.exports = __webpack_public_path__ + "722604fb6d0783abf330fe8a45557662.png";